var React = require('react');

function ColorFull (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"10","fill":"#fff","stroke":"#FC8309","strokeWidth":"1","key":0}),React.createElement("circle",{"cx":"10.886","cy":"15.79","r":"1.599","fill":"#FC8309","key":1}),React.createElement("path",{"fill":"#FC8309","d":"M14.191 7.795a3.198 3.198 0 1 0-6.395 0h6.395Z","key":2}),React.createElement("path",{"fill":"red","d":"M7.712 9.394 4.598 12.91h12.791l-3.238-3.517H7.71Z","key":3})]);
}

ColorFull.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = ColorFull;

ColorFull.default = ColorFull;
